import React, { useState } from "react";
import theme from "../../../styles/theme";
import Button from "../Forms/Button"; // ton bouton réutilisable

const SplitButton = ({ 
  label, 
  options = [], 
  onClick, 
  disabled = false 
}) => {
  const [open, setOpen] = useState(false);

  return (
    <div style={{ position: "relative", display: "inline-flex", gap: "2px" }}>
      {/* Bouton principal */}
      <Button variant="blue" onClick={onClick} disabled={disabled}>
        {label}
      </Button>

      {/* Bouton secondaire */}
      <Button 
        variant="blue" 
        onClick={() => setOpen(!open)} 
        disabled={disabled} 
        style={{ padding: `${theme.spacing.sm}px ${theme.spacing.sm}px` }}
      >
        ▼
      </Button>

      {/* Menu options */}
      {open && !disabled && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            right: 0,
            backgroundColor: theme.colors.background.surface,
            border: `1px solid ${theme.colors.borders.default}`,
            borderRadius: theme.borders.radius.sm,
            boxShadow: theme.shadows.md,
            zIndex: 10,
            marginTop: "2px",
            minWidth: "120px"
          }}
        >
          {options.map((opt, index) => (
            <div
              key={index}
              onClick={() => { opt.onClick(); setOpen(false); }}
              style={{
                padding: `${theme.spacing.sm}px ${theme.spacing.md}px`,
                cursor: "pointer",
                fontFamily: theme.fonts.primary,
                color: theme.colors.text.default,
                transition: "background-color 0.2s",
              }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = theme.colors.background.muted}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = theme.colors.background.surface}
            >
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SplitButton;
